<!-- 仅提供文字的连接 -->
<template>
    <div class="mylink">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "MyLink",
        props: {
            text: String
        },
        data(){
            return {

            }
        },
        methods: {
            clickme(){
                console.log('click workssss');
            }
        }
    }
</script>

<style>

    .mylink{
        display: inline-block;
    }

    .mylink:hover {
        color: #CB0101;
        cursor: pointer;
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/components/commons/MyLink.vue